import Link from '@eliadmin/core/src/components/link';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { Paragraph } from '../../ui/paragraph';

export function ProductDetailCategories({
  categories,
}: {
  categories: ProductDetailData['categories'];
}) {
  return (
    <div className="flex w-full flex-wrap items-start justify-start gap-[10px]">
      <Paragraph className="font-semibold" color="muted-foreground" size="sm">
        Kategórie
      </Paragraph>
      {categories?.map(category => (
        <Link
          key={category.id}
          prefetch={false}
          prefetchOnHover
          href={ROUTES.CATEGORY({ slug: category?.slug })}
          className="flex h-[21px] items-center justify-center whitespace-nowrap rounded-full border border-border px-3 py-1 text-center text-xs font-semibold transition-all ease-in-out hover:bg-border/20 sm:h-[23px] sm:text-sm"
        >
          {category.name}
        </Link>
      ))}
    </div>
  );
}
